<div class="admin-btn" *ngIf="role$ | async as role">
  <button
    *ngIf="role === 'Admin'"
    nzSize="large"
    nzType="primary"
    nz-button
    nz-dropdown
    [nzDropdownMenu]="menu"
    nzPlacement="bottomLeft"
  >
    <i nz-icon nzType="crown" nzTheme="outline"></i>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item routerLink="/admin/admins" routerLinkActive="ant-menu-item-selected">
          Admins
        </li>
        <li nz-menu-item routerLink="/admin/urls" routerLinkActive="ant-menu-item-selected">
          Quick URLs
        </li>
      </ul>
    </nz-dropdown-menu>
  </button>
</div>
